(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
    var url = window.location.href;
    var title = url.split("?title=");
    var title = title[1].split("?sku=");
    var title = title[0].replaceAll("%20", " ");
    $('.product-title').html(title);
    $('.pro_details').val(title);
    var url = url.split("?sku=");
    var url = url[1].split("&");
    var url = url[0];
    var params = url.replaceAll("%20", " ");
    $('.product-sku').html(params);
    $('.pro_sku').val(params);
  });
 
  } catch(e) { console.error(e); }
})();
})();
